import MenuSection from "../MenuSection";
import React, { useMemo } from "react";
import { MenuItemFactory } from "../MenuItemFactory";
import { usePCCategories } from "./hooks/usePCCategories";

const CategoriesPC = () => {
  const menuItemsList = usePCCategories();

  const components = useMemo(
    () =>
      menuItemsList?.map(menuItem => (
        <MenuItemFactory
          key={menuItem.key}
          componentProps={menuItem.props}
          componentType={menuItem.componentType}
        />
      )),
    [menuItemsList]
  );

  return <MenuSection className="categoriesSection">{components}</MenuSection>;
};

export default React.memo(CategoriesPC);
